import React from 'react';
import PageLayout from '../../components/Layout/PageLayout';

const Parameters = props => {
  return <PageLayout>{props.location.pathname}</PageLayout>;
};

export default Parameters;
